/** Product name placeholder: change it here only. */
export const PRODUCT_NAME = 'Falak';

/** Runtime configuration from Vite env vars (see STATUS 02f for the list). */
export const config = {
  apiMode: (import.meta.env.VITE_API_MODE === 'mock' ? 'mock' : 'live') as 'mock' | 'live',
  apiBase: import.meta.env.VITE_API_BASE ?? '/api',
  grafanaUrl: import.meta.env.VITE_GRAFANA_URL ?? 'http://localhost:3000',
  jaegerUrl: import.meta.env.VITE_JAEGER_URL ?? 'http://localhost:16686',
} as const;
